import React from 'react';

function SmallAppBar(props) {
    return (
        <div id="smallbarapp">           
        </div>
    );
}

export default SmallAppBar;